import { createElement, styled, compose, position, layout, flexbox, space, color, typography, border, opacity } from '@vebox/etui-system';

const AsideElement = createElement('aside');
const Aside = styled(AsideElement)(compose(position, layout, flexbox, space, color, typography, border, opacity));
Aside.displayName = 'Aside';

export { Aside };
